enum MembershipSlug {
	ACCOUNTING = 'ACC',
	ADVISING_DOCUMENT = 'AD',
	AiChatAccess = 'ai_chat_access',
	BILL_OF_LADING_TRANSPORT = 'BLT',
	CAPACITY_RADAR = 'CR',
	CARGO_PAGE = 'PC',
	CARGO_RADAR = 'CARGO_RADAR',
	CCR = 'CCR',
	CHLORIDE = 'CHR',
	COCKPIT_PAGE = 'skipper_hammock_page',
	CUSTOM_DOSSIER_NUMBER = 'CDN',
	DASHBOARD = 'DBI',
	DASHBOARD_TRANSPORT = 'DBT',
	DEPOT = 'DPT',
	DOWNLOAD_AUDIT_LOG = 'download_audit_log',
	EML = 'EML',
	FINANCIAL_REGISTRATION = 'TFR',
	LCI_DOCUMENT = 'LCI',
	INTERNAL_NOTES = 'internal_notes',
	INVENTORY_MANAGEMENT = 'VM',
	INVOICING_PAGE = 'PI',
	LEGACY_TRANSPORT_FINANCIALS = 'LTF',
	LOADING_BILL = 'BLBL',
	MAP_PAGE = 'PM',
	MESSAGES_PAGE = 'PMSG',
	OB = 'OB',
	PDT = 'PDT',
	PORT_MANAGEMENT = 'PMD',
	PRIVATE_CLIENT_COMMUNICATION = 'PCC',
	QUOTATION = 'quotation',
	RELATION_MANAGEMENT = 'RM',
	ROUTE_PLANNER_COST_QUOTATION = 'routeplanner_cost_quotation',
	ROUTE_PLANNER_PRO = 'routeplanner_pro',
	SUPPLEMENT_VESSEL_PUBLIC_DATA = 'supplement_vessel_public_data',
	TERMINAL_PAGE = 'TM',
	TFS = 'TFS',
	THIRD_PARTY_COLLABORATIONS = 'TPC',
	TRANSPORT_PAGE = 'PT'
}

export default MembershipSlug
